module.exports = __webpack_public_path__ + "img/videocall_black.6ecc412c.svg";